import { lazy } from '../../shared/deployment';

export const MyAssociationSummary = lazy(() => import('./summary/Summary'));
export const MyAssociationEvents = lazy(() => import('./event/Events'));
